import { render, staticRenderFns } from "./basicssetup.vue?vue&type=template&id=0bcf1fda&scoped=true&"
import script from "./basicssetup.vue?vue&type=script&lang=js&"
export * from "./basicssetup.vue?vue&type=script&lang=js&"
import style0 from "./basicssetup.vue?vue&type=style&index=0&id=0bcf1fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf1fda",
  null
  
)

export default component.exports